function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.86316 2.5848L11.9968 10.7124L20.044 2.6664C20.5924 2.178 21.16 2.4696 21.3868 2.7144C21.5322 2.89168 21.6073 3.11635 21.5975 3.34548C21.5878 3.5746 21.494 3.7921 21.334 3.9564L13.2856 12.0012L21.334 20.0436C21.6916 20.3436 21.6916 20.9316 21.4048 21.2604C21.1168 21.588 20.5888 21.7776 20.0908 21.3888L11.9968 13.29L3.89316 21.3924C3.53796 21.7104 2.95236 21.6456 2.66316 21.33C2.37276 21.0132 2.26236 20.466 2.63316 20.0796L10.708 12.0012L2.66676 3.9564C2.37276 3.6324 2.27076 3.0396 2.66676 2.6664C3.06276 2.2932 3.65316 2.3448 3.86316 2.5848Z",
  fill: "#062F53"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.5fb5de0a.svg";
export { ForwardRef as ReactComponent };